<template>
   <v-navigation-drawer
      v-model="Sidebar_drawer"
      :dark="SidebarColor !== 'white'"
      :color="SidebarColor"
      mobile-breakpoint="960"
      clipped
      :right="$vuetify.rtl"
      mini-variant-width="70"
      :expand-on-hover="expandOnHover"
      app
      id="main-sidebar"
      v-bar
   >
      <v-list-item two-line class="profile-bg">
         <v-list-item-avatar>
            <img
               :src="profilePhotoUrl"
               :alt="($page.user) ? $page.user.name : ''"
            />
         </v-list-item-avatar>
         <v-list-item-content>
            <v-list-item-title>{{ ($page.user) ? $page.user.name : '' }}</v-list-item-title>
            <v-list-item-subtitle class="caption">{{ ($page.user) ? $page.user.email : '' }}</v-list-item-subtitle>
         </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>

      <v-list expand nav class="mt-1">
         <template v-for="(item, i) in items">
            <v-row v-if="item.header && hasaccess('header', item)" :key="item.header" align="center">
               <v-col cols="12">
                  <v-subheader v-if="item.header" class="d-block text-truncate">
                     {{ item.header }}
                  </v-subheader>
               </v-col>
            </v-row>
            <BaseItemGroup
               v-else-if="item.children && hasaccess('child', item)"
               class="icon-size"
               :key="`group-${i}`"
               :item="item"
            ></BaseItemGroup>
            <BaseItem v-else-if="hasaccess('child', item)" :key="`item-${i}`" :item="item" />
         </template>
      </v-list>
   </v-navigation-drawer>
</template>

<script>
import { mapState } from "vuex";
import MenuItems from "./MenuItems";
import BaseItemGroup from '@/components/BaseItemGroup.vue'
import BaseItem from '@/components/BaseItem.vue'
const axios = require('axios')

export default {
   name: "VerticalSidebar",

   components: {
      BaseItemGroup,
      BaseItem,
   },

   props: {
      expandOnHover: {
         type: Boolean,
         default: false,
      },
   },

   data() {
      return {
         items: MenuItems,
         moduleStatus: {},
         modulesLoaded: false,
      }
   },

   mounted() {
      this.loadModules()
   },

   computed: {
      ...mapState(["SidebarColor", "SidebarBg"]),
      Sidebar_drawer: {
         get() {
         return this.$store.state.Sidebar_drawer;
         },
         set(val) {
         this.$store.commit("SET_SIDEBAR_DRAWER", val);
         },
      },
      profilePhotoUrl() {
         const user = this.$page && this.$page.user ? this.$page.user : null
         if (!user) {
            return ''
         }

         return user.id ? `/member/photo/${user.id}?v=${Date.now()}` : (user.profile_photo_url || '')
      },
   },

   watch: {
      "$vuetify.breakpoint.smAndDown"(val) {
         this.$emit("update:expandOnHover", !val);
      },
   },

   methods: {
      loadModules() {
         axios.get('/member/modules')
            .then((resp) => {
               if (resp.data && resp.data.status === 'OK' && Array.isArray(resp.data.data)) {
                  const map = {}
                  resp.data.data.forEach((module) => {
                     map[module.modulename] = !!Number(module.isenabled)
                  })
                  this.moduleStatus = map
               }
            })
            .finally(() => {
               this.modulesLoaded = true
            })
      },

      hasaccess(pType, pItem) {
         if ((pType === 'header') && (this.$page.user)) {
            if (pItem.grantaccess.length > 0) {
               return this.hasgrantaccess(pItem) && this.hasmemberstatusaccess(pItem)
            }
         }

         if ((pType === 'child') && (this.$page.user)) {
            if (pItem.grantaccess.length > 0) {
               return this.hasgrantaccess(pItem) && this.hasmemberstatusaccess(pItem) && this.hasmoduleaccess(pItem) && this.hasagmaccess(pItem)
            }
         }
         return false
      },

      hasgrantaccess(pItem) {
         return pItem.grantaccess.includes("all", 0) || pItem.grantaccess.includes(this.$page.user.usertype, 0)
      },

      hasmoduleaccess(pItem) {
         if (!pItem.requireModule) {
            return true
         }

         if (!this.modulesLoaded) {
            return true
         }

         if (!(pItem.requireModule in this.moduleStatus)) {
            return true
         }

         return this.moduleStatus[pItem.requireModule]
      },

      hasagmaccess(pItem) {
         if (!pItem.requireAccess) {
            return true
         }

         if (this.$page.user.usertype !== 'members') {
            return true
         }

         const agmAccess = this.$page.agmAccess || {}
         return agmAccess[pItem.requireAccess] === true
      },

      hasmemberstatusaccess(pItem) {
         if (this.$page.user.usertype !== 'members') {
            return true
         }

         const member = this.$page.member
         const memberstatus = member ? parseInt(member.memberstatus) : null
         const corporateStatus = member ? parseInt(member.applcorpstatus || 0) : 0

         if (pItem.membertypes && pItem.membertypes.length > 0) {
            return !!member && pItem.membertypes.includes(member.membertype)
               && (!pItem.requireActiveMember || memberstatus === 3)
         }

         if (pItem.corporateUpgradeAccess) {
            return !!member && (
               (member.membertype === 'GRA' && memberstatus === 3)
               || (member.applcorp_previous_membertype === 'GRA' && [1, 4].includes(corporateStatus))
            )
         }

         if (pItem.requireActiveMember) {
            return memberstatus === 3
         }

         if (pItem.memberstatuses && pItem.memberstatuses.length > 0) {
            return pItem.memberstatuses.includes(memberstatus)
         }

         return true
      }
   },
};
</script>

<style lang="scss">
#main-sidebar {
  box-shadow: 1px 0 20px rgba(0, 0, 0, 0.08);
  -webkit-box-shadow: 1px 0 20px rgba(0, 0, 0, 0.08);
  .v-navigation-drawer__border {
    display: none;
  }
  .v-list {
    padding: 8px 15px;
  }
  .v-list-item {
    min-height: 35px;
    &__icon--text,
    &__icon:first-child {
      justify-content: center;
      text-align: center;
      width: 20px;
    }
  }
  .v-list-item__icon i {
    width: 20px;
  }
  .icon-size .v-list-group__items i {
    width: 16px;
    font-size: 16px;
  }
  .profile-bg {
    &.theme--dark.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
      opacity: 1;
    }
    .v-avatar {
      padding: 15px 0;
    }
  }
  .theme--dark.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
    opacity: 0.5;
    &:hover {
      opacity: 1;
    }
  }
}
</style>
